import { ProjektHubView } from "../VIEW/ProjektHubView";

function ProjektPage() {
  return <ProjektHubView />;
}

export default ProjektPage;
